import {
  ArrowForwardIos,
  ArrowForwardIosRounded,
  ArrowBackIosNew,
  ArrowBackIosRounded,
  MenuRounded,
  CloseRounded,
  Instagram,
  WifiRounded,
  LocalLaundryServiceRounded,
  BedRounded,
  SingleBedRounded,
  ChairRounded,
  MapRounded,
  Menu,
  Close,
  MailRounded,
  PhoneRounded,
  BedroomParentOutlined,
  BedroomChildOutlined,
  AcUnitRounded,
  ChairOutlined,
  FacebookRounded,
  StarRateRounded,
  StarHalfRounded,
  ArrowOutwardRounded,
} from "@mui/icons-material";

import { BedDouble, BedSingle, AirVent, Wifi, Sofa } from "lucide-react";

export const IconsList = {
  ArrowForwardIos,
  ArrowForwardIosRounded,
  ArrowBackIosNew,
  ArrowBackIosRounded,
  MenuRounded,
  CloseRounded,
  Instagram,
  MailRounded,
  MapRounded,
  PhoneRounded,
  WifiRounded,
  BedRounded,
  SingleBedRounded,
  ChairRounded,
  LocalLaundryServiceRounded,
  Sofa: ChairOutlined,
  DoubleBed: BedDouble,
  SingleBed: BedSingle,
  AirConditioning: AirVent,
  Facebook: FacebookRounded,
  WifiLucide: Wifi,
  SofaLucide: Sofa,
  Star: StarRateRounded,
  HalfStar: StarHalfRounded,
  LinkArrow: ArrowOutwardRounded,
  Menu,
  Close,
};
